class ComponentProductCard extends HTMLElement {
  constructor() {
    super();
    this.quickViewBtn = this.querySelector(".quick-view-trigger");
    this.quickViewBundleBtn = this.querySelector(".quick-view-bundle-trigger");
    this.swatches = this.querySelector(".swatch-group");
    this.productCardUrl = this.querySelector(".product-card-url");
    this.variantAvailable = this.querySelector(".variant-available");
    this.productVariant = this.querySelector("product-variants");
    this.isBundleBuilder = this.classList.contains("bundle-card");

    this.colorHover = this.querySelector(".color-hover");

    if (this.quickViewBtn)
      this.quickViewBtn.addEventListener(
        "click",
        this.openQuickView.bind(this)
      );
    if (this.quickViewBundleBtn)
      this.quickViewBundleBtn.addEventListener(
        "click",
        this.bundleAdd.bind(this)
      );

    if (this.swatches)
      this.swatches.querySelectorAll("input").forEach((input) => {
        input.addEventListener("change", this.onSwatchChange.bind(this));
      });

    if (this.swatches && this.colorHover && !this.isBundleBuilder)
      this.swatches.querySelectorAll(".swatch").forEach((el) => {
        el.addEventListener(
          "mouseover",
          () => (this.colorHover.innerHTML = el.querySelector("input").value),
          false
        );
        el.addEventListener(
          "mouseout",
          () => (this.colorHover.innerHTML = ""),
          false
        );
      });

    if (this.swatches) {
      if (this.swatches.dataset.defaultVariant) {
        this.swatches.querySelector(
          "#swatch-" + this.swatches.dataset.defaultVariant
        ).checked = true;
        this.initialSwatchChange();
      } else if (this.swatches.querySelector("input")) {
        this.swatches.querySelector("input").checked = true;
        this.initialSwatchChange();
      }
    }
  }

  bundleAdd(e) {
    e.preventDefault();
    this.querySelector("product-buttons > .btn").click();
  }

  openQuickView(e) {
    e.preventDefault();
    $s.showLoadingOverlay();
    var qvUrl = this.quickViewBtn.dataset.url;
    qvUrl += (qvUrl.indexOf("?") > 0 ? "&" : "?") + "sections=product_main";
    $s.getJson({
      url: qvUrl,
      success: (data) => {
        $s.openModal(data["product_main"], "product-quick-view");
        $s.globalEval(data["product_main"]);
      },
      always: (data) => {
        $s.hideLoadingOverlay();
      },
    });
  }

  initialSwatchChange() {
    var checkedOption = this.querySelector("input:checked");
    var variantImg = checkedOption.dataset.variantImg;
    var variantUrl = checkedOption.dataset.variantUrl;
    var priceFinal = checkedOption.dataset.priceFinal;
    var priceCompare = checkedOption.dataset.priceCompare;
    var priceFinalNumeric = checkedOption.dataset.priceFinalNumeric;
    var priceCompareNumeric = checkedOption.dataset.priceCompareNumeric;
    var variantLabel = checkedOption.value;

    this.querySelector(".color-checked")
      ? (this.querySelector(".color-checked").innerHTML = variantLabel)
      : "";

    this.querySelector(".product-card-url").setAttribute("href", variantUrl);

    if (this.querySelector(".quick-view-trigger")) {
      this.querySelector(".quick-view-trigger").setAttribute(
        "data-url",
        variantUrl
      );
    }
    if (this.querySelector(".final")) {
      this.querySelector(".final").innerHTML = priceFinal;
    }
    if (this.querySelector(".from")) {
      this.querySelector(".from").style.display = "none";
    }
    if (priceCompare) {
      this.querySelector(".compare").innerHTML = priceCompare;
      this.querySelector(".compare").style.display = "block";
    } else {
      if (this.querySelector(".compare")) {
        this.querySelector(".compare").style.display = "none";
      }
    }
    
    // update savings percentage
    var savingsPercentageElement = this.querySelector(".savings-percentage");
    if (savingsPercentageElement && priceCompareNumeric && priceFinalNumeric) {
      var comparePrice = parseFloat(priceCompareNumeric);
      var finalPrice = parseFloat(priceFinalNumeric);
      if (comparePrice > finalPrice) {
        var savingsPercentage = Math.floor((comparePrice - finalPrice) * 100 / comparePrice);
        savingsPercentageElement.textContent = '(' + savingsPercentage + '% off)';
        savingsPercentageElement.classList.remove('hide');
      } else {
        savingsPercentageElement.classList.add('hide');
      }
    } else if (savingsPercentageElement) {
      savingsPercentageElement.classList.add('hide');
    }
    if (variantImg) {
      var elemToObserve = this.querySelector(".img.main");
      if (elemToObserve) {
        var prevClassState = elemToObserve.classList.contains("lazyload");
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName == "class") {
              var currentClassState =
                mutation.target.classList.contains("lazyloaded");
              if (prevClassState !== currentClassState) {
                prevClassState = currentClassState;
                if (currentClassState) {
                  elemToObserve.setAttribute("srcset", variantImg);
                  let elemParent = elemToObserve.parentElement.querySelector(
                    ".img.hover-img." +
                      variantLabel.toLowerCase().replaceAll(" ", "-")
                  );
                  if (elemParent) elemParent.classList.remove("hide");
                }
              }
            }
          });
        });
        observer.observe(elemToObserve, { attributes: true });
      }
    }
  }

  onSwatchChange() {
    var checkedOption = this.querySelector("input:checked");
    var variantImg = checkedOption.dataset.variantImg;
    var variantUrl = checkedOption.dataset.variantUrl;
    var priceFinal = checkedOption.dataset.priceFinal;
    var priceCompare = checkedOption.dataset.priceCompare;
    var priceFinalNumeric = checkedOption.dataset.priceFinalNumeric;
    var priceCompareNumeric = checkedOption.dataset.priceCompareNumeric;
    var variantLabel = checkedOption.value;

    this.querySelector(".color-checked")
      ? (this.querySelector(".color-checked").innerHTML = variantLabel)
      : "";

    this.querySelector(".product-card-url").setAttribute("href", variantUrl);

    if (this.querySelector(".quick-view-trigger")) {
      this.querySelector(".quick-view-trigger").setAttribute(
        "data-url",
        variantUrl
      );
    }
    if (this.querySelector(".final")) {
      this.querySelector(".final").innerHTML = priceFinal;
    }
    if (this.querySelector(".from")) {
      this.querySelector(".from").style.display = "none";
    }
    if (priceCompare) {
      this.querySelector(".compare").innerHTML = priceCompare;
      this.querySelector(".compare").style.display = "block";
    } else {
      if (this.querySelector(".compare")) {
        this.querySelector(".compare").style.display = "none";
      }
    }
    
    // update savings percentage
    var savingsPercentageElement = this.querySelector(".savings-percentage");
    if (savingsPercentageElement && priceCompareNumeric && priceFinalNumeric) {
      var comparePrice = parseFloat(priceCompareNumeric);
      var finalPrice = parseFloat(priceFinalNumeric);
      if (comparePrice > finalPrice) {
        var savingsPercentage = Math.floor((comparePrice - finalPrice) * 100 / comparePrice);
        savingsPercentageElement.textContent = '(' + savingsPercentage + '% off)';
        savingsPercentageElement.classList.remove('hide');
      } else {
        savingsPercentageElement.classList.add('hide');
      }
    } else if (savingsPercentageElement) {
      savingsPercentageElement.classList.add('hide');
    }
    if (variantImg) {
      this.querySelector(".img.main").setAttribute("srcset", variantImg);
      this.querySelector(
        ".img.hover-img." + variantLabel.toLowerCase().replaceAll(" ", "-")
      ).classList.remove("hide");
    }
  }
}
customElements.define("product-card", ComponentProductCard);
